import { render, staticRenderFns } from "./OfficialNewsDetail.vue?vue&type=template&id=3dfb49e8&scoped=true&"
import script from "./OfficialNewsDetail.vue?vue&type=script&lang=js&"
export * from "./OfficialNewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./OfficialNewsDetail.vue?vue&type=style&index=0&id=3dfb49e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfb49e8",
  null
  
)

export default component.exports